/**
 * Drawing draft management utilities
 *
 * Provides functions for managing localStorage keys and cleanup for drawing drafts.
 * Drafts are stored temporarily to prevent data loss during the drawing process.
 */

const DRAFT_KEY_PREFIX = "drawing-draft-";

/**
 * Generates a unique localStorage key for a drawing draft
 *
 * @param storyId - The ID of the story
 * @param stepId - The ID of the story step
 * @returns A unique localStorage key for this drawing draft
 */
export function getDrawingDraftKey(storyId: string, stepId: string): string {
    return `${DRAFT_KEY_PREFIX}story-${storyId}-step-${stepId}`;
}

/**
 * Removes a drawing draft from localStorage
 *
 * Safely handles localStorage errors to prevent breaking core functionality.
 * Should be called when a drawing is successfully submitted or when cleanup is needed.
 *
 * @param storyId - The ID of the story
 * @param stepId - The ID of the story step
 */
export function clearDrawingDraft(storyId: string, stepId: string): void {
    try {
        const draftKey = getDrawingDraftKey(storyId, stepId);
        localStorage.removeItem(draftKey);
    } catch (error) {
        // Silently handle localStorage errors - don't let draft cleanup break core functionality
        console.warn("Failed to clear drawing draft:", error);
    }
}
